

import React, { useState, useRef } from 'react'; // ✅ include useRef
import * as XLSX from 'xlsx';
import axios from 'axios';
import Swal from 'sweetalert2';

const ExcelImport = () => {
  const [excelData, setExcelData] = useState<any[]>([]);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const MAX_CALLS = 10; // 🔟 Fixed API calls

  // 📥 Excel File Read
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target?.result as string;
      const workbook = XLSX.read(bstr, { type: 'binary' });
      const worksheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheetName];
      const rawData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

      const formattedData = rawData.map((row: any) => {
        let formattedDate = row.BOOKDATE;

        if (typeof row.BOOKDATE === 'number') {
          const dateCode = XLSX.SSF.parse_date_code(row.BOOKDATE);
          if (dateCode) {
            const day = String(dateCode.d).padStart(2, '0');
            const month = String(dateCode.m).padStart(2, '0');
            const year = dateCode.y;
            formattedDate = `${day}/${month}/${year}`;
          }
        }

        return { ...row, BOOKDATE: formattedDate };
      });

      setExcelData(formattedData);
      setProgress(0);
    };

    reader.readAsBinaryString(file);
  };

  // 🔁 Upload in 10 Chunks
  const handleUpload = async () => {
    if (excelData.length === 0) {
      Swal.fire('No Data', 'Please select an Excel file first.', 'warning');
      return;
    }

    setUploading(true);
    setProgress(0);

    const chunkSize = Math.ceil(excelData.length / MAX_CALLS); // 👈 10 chunks max
    let successCount = 0;

    for (let i = 0; i < MAX_CALLS; i++) {
      const start = i * chunkSize;
      const end = start + chunkSize;
      const chunk = excelData.slice(start, end);

      if (chunk.length === 0) continue;

      try {
        const response = await axios.post('http://localhost:2600/EXCELIMPORT', {
          exelData: chunk,

        });

        if (response.data.status === 1) {
          successCount += chunk.length;
        }
      } catch (err) {
        console.error(`Chunk ${i + 1} failed`, err);
      }

      setProgress(((i + 1) / MAX_CALLS) * 100);
    }

    setUploading(false);

    if (successCount > 0) {
      Swal.fire('Upload Complete', `✅ ${successCount} of ${excelData.length} rows uploaded.`, 'success');
      setExcelData([]);

      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } else {
      Swal.fire('Upload Failed', '❌ All rows failed to upload.', 'error');
    }
  };

  return (
    <div style={{ padding: '30px', maxWidth: '500px', margin: 'auto' }}>
      <h3>📤 Excel Upload (10 API Calls)</h3>

      <input
        ref={fileInputRef}
        type="file"
        accept=".xlsx, .xls"
        onChange={handleFileChange}
        className="form-control mb-3"
      />

      <button
        onClick={handleUpload}
        disabled={uploading || excelData.length === 0}
        className="btn btn-primary mb-3"
      >
        {uploading ? 'Uploading...' : 'Start Upload'}
      </button>

      {uploading && (
        <div>
          <div style={{ background: '#e0e0e0', borderRadius: '4px', height: '20px' }}>
            <div
              style={{
                width: `${progress}%`,
                backgroundColor: '#4caf50',
                height: '100%',
                borderRadius: '4px',
                transition: 'width 0.5s ease-in-out',
              }}
            />
          </div>
          <p className="text-center mt-2">{progress}% completed</p>
        </div>
      )}
    </div>
  );
};

export default ExcelImport;



